import isBrowser from './isBrowser';

const REFERRER_OVERRIDE_KEY = '__cvnaEventableReferrerOverride__';

interface WindowWithReferrerOverride extends Window {
  [REFERRER_OVERRIDE_KEY]?: string;
}

export const setReferrer = (url: string): void => {
  if (!isBrowser) return;
  (window as WindowWithReferrerOverride)[REFERRER_OVERRIDE_KEY] = url;
};

export const clearReferrer = (): void => {
  if (!isBrowser) return;
  delete (window as WindowWithReferrerOverride)[REFERRER_OVERRIDE_KEY];
};

export const getReferrerOverride = (): string | undefined => {
  if (!isBrowser) return undefined;
  return (window as WindowWithReferrerOverride)[REFERRER_OVERRIDE_KEY];
};
